import type { MediaType } from '@/types/lesson';
import type { StepView } from '@/types/pipeline';

/** The view a lesson opens on without a `?view=`: always its Overview (the
 *  `mindmap` view) - what the lesson teaches, before the text that teaches
 *  it - whether the lesson is still being written or long finished.
 *  `fallback` only for a lesson with no overview at all (an older lesson,
 *  or a flow without the mind map step). */
export function openingMediaType(
  steps: Record<string, StepView> | undefined,
  fallback: MediaType
): MediaType {
  return steps?.mindmap ? 'mindmap' : fallback;
}
